import { render, staticRenderFns } from "./function-manage.vue?vue&type=template&id=5c0d5c22&scoped=true"
import script from "./function-manage.vue?vue&type=script&lang=js"
export * from "./function-manage.vue?vue&type=script&lang=js"
import style0 from "./function-manage.vue?vue&type=style&index=0&id=5c0d5c22&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0d5c22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c0d5c22')) {
      api.createRecord('5c0d5c22', component.options)
    } else {
      api.reload('5c0d5c22', component.options)
    }
    module.hot.accept("./function-manage.vue?vue&type=template&id=5c0d5c22&scoped=true", function () {
      api.rerender('5c0d5c22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/user-manage/function-manage.vue"
export default component.exports